import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import Navbar from './Navbar';
import './App.css';

interface BlogPostData {
  id: string;
  title: string;
  slug: string;
  excerpt: string | null;
  content: string;
  author: string;
  image_url: string | null;
  published_at: string;
}

function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).toLowerCase();
}

function BlogPost() {
  const { slug } = useParams<{ slug: string }>();
  const [post, setPost] = useState<BlogPostData | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetch(`/api/blog/${slug}`)
      .then(res => {
        if (!res.ok) throw new Error('Not found');
        return res.json();
      })
      .then(data => setPost(data.post))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="App info-page">
      <Navbar />
      <div className="info-content">
        <div className="info-container">
          {loading && <p>loading...</p>}

          {notFound && (
            <>
              <h1>post not found</h1>
              <p><Link to="/blog">back to blog</Link></p>
            </>
          )}

          {post && (
            <article>
              <h1 style={{ marginBottom: '8px' }}>{post.title}</h1>
              <p style={{ fontSize: '14px', color: '#888', marginBottom: '32px' }}>
                {formatDate(post.published_at)}
              </p>
              {post.image_url && (
                <img
                  src={post.image_url}
                  alt={post.title}
                  style={{
                    width: '100%',
                    marginBottom: '32px',
                    display: 'block',
                    borderRadius: '4px'
                  }}
                />
              )}
              <div className="blog-content">
                <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                  {post.content}
                </ReactMarkdown>
              </div>
              <p style={{ marginTop: '32px', fontStyle: 'italic' }}>— {post.author}</p>

              <div style={{ marginTop: '60px', paddingTop: '30px', borderTop: '1px solid #d0d0c0' }}>
                <Link to="/blog" style={{ color: '#666', textDecoration: 'none' }}>
                  &larr; back to blog
                </Link>
              </div>
            </article>
          )}
        </div>
      </div>
    </div>
  );
}

export default BlogPost;
